import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { BoltIcon, WifiIcon, TvIcon, SmartphoneIcon, HomeIcon, SearchIcon, ClockIcon, GlobeIcon } from 'lucide-react';
export function BillPayment() {
  const africanCountries = ['Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cameroon', 'Central African Republic', 'Chad', 'Comoros', 'Congo', 'Djibouti', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Ethiopia', 'Gabon', 'Gambia', 'Ghana', 'Guinea', 'Guinea-Bissau', 'Ivory Coast', 'Kenya', 'Lesotho', 'Liberia', 'Libya', 'Madagascar', 'Malawi', 'Mali', 'Mauritania', 'Mauritius', 'Morocco', 'Mozambique', 'Namibia', 'Niger', 'Nigeria', 'Rwanda', 'Sao Tome and Principe', 'Senegal', 'Seychelles', 'Sierra Leone', 'Somalia', 'South Africa', 'South Sudan', 'Sudan', 'Tanzania', 'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe'];
  return <div data-id="element-89">
      <PageHeader title="Bill Payment" description="Pay your bills quickly and securely across Africa" data-id="element-90" />
      <div className="mb-6" data-id="element-91">
        <Card title="African Coverage" data-id="element-92">
          <div className="flex items-start" data-id="element-93">
            <div className="flex-shrink-0 mt-1" data-id="element-94">
              <GlobeIcon className="h-6 w-6 text-blue-500" data-id="element-95" />
            </div>
            <div className="ml-3" data-id="element-96">
              <p className="text-gray-600" data-id="element-97">
                Oxy Pay provides bill payment services across all 54 African
                countries. Pay utility bills, airtime, TV subscriptions, and
                more with ease and security.
              </p>
            </div>
          </div>
        </Card>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-98">
        <div className="lg:col-span-2" data-id="element-99">
          <Card title="Pay a Bill" data-id="element-100">
            <div className="mb-6" data-id="element-101">
              <div className="relative mb-4" data-id="element-102">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-103">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-104" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search for a biller..." data-id="element-105" />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-id="element-106">
                <BillCategory icon={<BoltIcon className="h-6 w-6" data-id="element-108" />} name="Electricity" data-id="element-107" />
                <BillCategory icon={<WifiIcon className="h-6 w-6" data-id="element-110" />} name="Internet" data-id="element-109" />
                <BillCategory icon={<TvIcon className="h-6 w-6" data-id="element-112" />} name="Cable TV" data-id="element-111" />
                <BillCategory icon={<SmartphoneIcon className="h-6 w-6" data-id="element-114" />} name="Mobile" data-id="element-113" />
                <BillCategory icon={<HomeIcon className="h-6 w-6" data-id="element-116" />} name="Rent" data-id="element-115" />
                <BillCategory icon={<BoltIcon className="h-6 w-6" data-id="element-118" />} name="Water" data-id="element-117" />
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6" data-id="element-119">
              <h3 className="text-lg font-medium mb-4" data-id="element-120">Popular Billers</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-121">
                {[{
                name: 'PHCN Nigeria',
                category: 'Electricity',
                logo: 'P',
                country: 'Nigeria'
              }, {
                name: 'Water Utilities Corp',
                category: 'Water',
                logo: 'W',
                country: 'Botswana'
              }, {
                name: 'MTN',
                category: 'Mobile',
                logo: 'M',
                country: 'Multiple Countries'
              }, {
                name: 'DSTV',
                category: 'Cable TV',
                logo: 'D',
                country: 'Multiple Countries'
              }, {
                name: 'Safaricom',
                category: 'Internet',
                logo: 'S',
                country: 'Kenya'
              }, {
                name: 'Eskom',
                category: 'Electricity',
                logo: 'E',
                country: 'South Africa'
              }].map((biller, i) => <div key={i} className="border rounded-lg p-4 hover:border-blue-500 cursor-pointer" data-id="element-122">
                    <div className="flex items-center" data-id="element-123">
                      <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold" data-id="element-124">
                        {biller.logo}
                      </div>
                      <div className="ml-4" data-id="element-125">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-126">
                          {biller.name}
                        </h4>
                        <p className="text-xs text-gray-500" data-id="element-127">
                          {biller.category} • {biller.country}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </Card>
        </div>
        <div data-id="element-128">
          <Card title="Payment Form" data-id="element-129">
            <form className="space-y-4" data-id="element-130">
              <div data-id="element-131">
                <label htmlFor="country" className="block text-sm font-medium text-gray-700" data-id="element-132">
                  Country
                </label>
                <select id="country" name="country" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-133">
                  <option value="" data-id="element-134">Select a country</option>
                  {africanCountries.map(country => <option key={country} data-id="element-135">{country}</option>)}
                </select>
              </div>
              <div data-id="element-136">
                <label htmlFor="biller" className="block text-sm font-medium text-gray-700" data-id="element-137">
                  Select Biller
                </label>
                <select id="biller" name="biller" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-138">
                  <option value="" data-id="element-139">Select a biller</option>
                  <option data-id="element-140">PHCN Nigeria</option>
                  <option data-id="element-141">Water Utilities Corp</option>
                  <option data-id="element-142">MTN</option>
                  <option data-id="element-143">DSTV</option>
                  <option data-id="element-144">Safaricom</option>
                  <option data-id="element-145">Eskom</option>
                </select>
              </div>
              <div data-id="element-146">
                <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700" data-id="element-147">
                  Account Number
                </label>
                <input type="text" name="accountNumber" id="accountNumber" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter account number" data-id="element-148" />
              </div>
              <div data-id="element-149">
                <label htmlFor="amount" className="block text-sm font-medium text-gray-700" data-id="element-150">
                  Amount
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-151">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-152">
                    <span className="text-gray-500 sm:text-sm" data-id="element-153">$</span>
                  </div>
                  <input type="text" name="amount" id="amount" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-154" />
                </div>
              </div>
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-155">
                Pay Bill
              </button>
            </form>
          </Card>
          <Card title="Payment History" className="mt-6" data-id="element-156">
            <div className="space-y-4" data-id="element-157">
              {[{
              biller: 'PHCN Nigeria',
              amount: '$120.50',
              date: 'Jul 15, 2023',
              status: 'Completed'
            }, {
              biller: 'MTN',
              amount: '$75.00',
              date: 'Jul 05, 2023',
              status: 'Completed'
            }, {
              biller: 'DSTV',
              amount: '$45.99',
              date: 'Jun 28, 2023',
              status: 'Completed'
            }].map((payment, i) => <div key={i} className="flex justify-between items-center border-b pb-2 last:border-b-0 last:pb-0" data-id="element-158">
                  <div data-id="element-159">
                    <p className="font-medium" data-id="element-160">{payment.biller}</p>
                    <p className="text-xs text-gray-500 flex items-center" data-id="element-161">
                      <ClockIcon className="h-3 w-3 mr-1" data-id="element-162" /> {payment.date}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-163">
                    <p className="font-medium" data-id="element-164">{payment.amount}</p>
                    <p className="text-xs text-green-600" data-id="element-165">{payment.status}</p>
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}
function BillCategory({
  icon,
  name
}: {
  icon: React.ReactNode;
  name: string;
}) {
  return <div className="flex flex-col items-center p-3 border rounded-lg hover:border-blue-500 hover:bg-blue-50 cursor-pointer" data-id="element-166">
      <div className="text-blue-600 mb-2" data-id="element-167">{icon}</div>
      <span className="text-sm text-center" data-id="element-168">{name}</span>
    </div>;
}